import { Select } from 'enova-frontend-components';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';

import { AboutFormControlProps } from '../../types';
import { VentilasjonVarmegjenvinningsType } from '../../../../../utils/registerEnums';

export const VarmegjenvinnerSelect: FC<AboutFormControlProps> = ({ control }) => {
  const { t } = useTranslation();

  const options = [
    {
      disabled: true,
      label: t('register.ventilation.gjenvinningsType.option.default'),
      value: -1
    },
    ...[
      VentilasjonVarmegjenvinningsType.VentilasjonMedBatterigjenvinner,
      VentilasjonVarmegjenvinningsType.VentilasjonMedPlategjenvinner,
      VentilasjonVarmegjenvinningsType.VentilasjonMedRoterendeGjenvinner,
      VentilasjonVarmegjenvinningsType.VentilasjonMedKammergjenvinner,
      VentilasjonVarmegjenvinningsType.Ukjent
    ].map((option) => ({
      label: t(`register.ventilation.gjenvinningsType.option.${option}`),
      value: option
    }))
  ];

  return (
    <Controller
      name="ventilasjon.gjenvinningsType"
      control={control}
      render={({ field, fieldState }) => (
        <Select
          label={t('register.ventilation.gjenvinningsType.label')}
          required
          options={options}
          value={field.value ?? -1}
          onChange={({ currentTarget: { value: val } }) => field.onChange(val)}
          error={!!fieldState.error}
          helperText={fieldState.error && t(`${fieldState.error.message}`)}
        />
      )}
    />
  );
};
